module.exports = __webpack_public_path__ + "static/img/xiaofangche.0a6eed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiaofangche.png
// module id = MUab
// module chunks = 21